import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-121">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-122">
        <div className="flex items-center" data-id="element-123">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mJUAQFcEAD6vk4sgcnnP18/Ikoon.png" alt="Bivek Logo" className="h-12" data-id="element-124" />
          <div className="ml-4" data-id="element-125">
            <h1 className="text-xl font-bold text-gray-900" data-id="element-126">BIVEK</h1>
            <p className="text-xs text-gray-600" data-id="element-127">Mööblipaigaldus</p>
          </div>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-128">
          <a href="#teenused" className="text-gray-700 hover:text-blue-900" data-id="element-129">
            Teenused
          </a>
          <a href="#meist" className="text-gray-700 hover:text-blue-900" data-id="element-130">
            Meist
          </a>
          <a href="#galerii" className="text-gray-700 hover:text-blue-900" data-id="element-131">
            Galerii
          </a>
          <a href="#kontakt" className="text-gray-700 hover:text-blue-900" data-id="element-132">
            Kontakt
          </a>
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-133">
          {isMenuOpen ? <XIcon size={24} data-id="element-134" /> : <MenuIcon size={24} data-id="element-135" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <nav className="md:hidden bg-white px-4 py-2 shadow-md" data-id="element-136">
          <div className="flex flex-col space-y-3" data-id="element-137">
            <a href="#teenused" className="text-gray-700 hover:text-blue-900 py-2" onClick={() => setIsMenuOpen(false)} data-id="element-138">
              Teenused
            </a>
            <a href="#meist" className="text-gray-700 hover:text-blue-900 py-2" onClick={() => setIsMenuOpen(false)} data-id="element-139">
              Meist
            </a>
            <a href="#galerii" className="text-gray-700 hover:text-blue-900 py-2" onClick={() => setIsMenuOpen(false)} data-id="element-140">
              Galerii
            </a>
            <a href="#kontakt" className="text-gray-700 hover:text-blue-900 py-2" onClick={() => setIsMenuOpen(false)} data-id="element-141">
              Kontakt
            </a>
          </div>
        </nav>}
    </header>;
};
export default Header;